var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-white mr-3 print-button",domProps:{"innerHTML":_vm._s(_vm.ic('filter') + _vm.text)},on:{"click":_vm.action}})
}
var staticRenderFns = []

export { render, staticRenderFns }